import { atom } from 'recoil'

export const modalStopSendingState = atom({
  key: 'scheduledSendingsModalStopSendingState',
  default: {
    show: false,
    idSending: undefined,
    mode: undefined
  }
})

export const modalStopCampaignState = atom({
  key: 'scheduledSendingsModalStopCampaignState',
  default: {
    show: false,
    idSending: undefined,
    idSource: undefined,
    mode: undefined
  }
})

export const modalDeleteSendingState = atom({
  key: 'scheduledSendingsModalDeleteSendingState',
  default: {
    show: false,
    idSending: undefined
  }
})

export const modalSendingSegmentationState = atom({
  key: 'scheduledSendingsModalSendingSegmentationState',
  default: {
    show: false,
    loading: false,
    error: undefined,
    severity: undefined,
    queued: undefined,
    groups: [],
    excludedGroups: [],
    filters: [],
    section: 'groups',
    idMessage: undefined,
    idSending: undefined,
    simulationEnabled: false,
    simulationLoading: false,
    simulationLoaded: false,
    simulationResult: undefined,
    simulationDiff: undefined

  }
})

export const modalScheduleSendingState = atom({
  key: 'scheduledSendingsModalScheduleSendingState',
  default: {
    show: false,
    idSending: undefined,
    idList: undefined,
    startDate: undefined,
    timeZoneCode: undefined,
    countImmediate: undefined,
    error: undefined,
    severity: undefined,
    sending: false
  }
})
